import { render, staticRenderFns } from "./SandboxBtn.vue?vue&type=template&id=5508bd50&"
import script from "./SandboxBtn.vue?vue&type=script&lang=ts&"
export * from "./SandboxBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5508bd50')) {
      api.createRecord('5508bd50', component.options)
    } else {
      api.reload('5508bd50', component.options)
    }
    module.hot.accept("./SandboxBtn.vue?vue&type=template&id=5508bd50&", function () {
      api.rerender('5508bd50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/SandboxBtn.vue"
export default component.exports